import { defineComponent as _defineComponent } from 'vue'
import { type PropType, computed, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useVuetify } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";
import { useCreatorShop } from "@/store/creator-shop";
import { getProductSetsStore } from "@/store/product-sets";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSetSlidegroup',
  props: {
  displayName: {
    type: String,
    required: true,
  },
  currentId: {
    type: String as PropType<string | undefined>,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;



const store = useStore();
const amplitude = useAmplitude();
const vuetify = useVuetify();

const MIN_NUM_OF_PRODUCT_SETS_MOBILE = 2;
const MIN_NUM_OF_PRODUCT_SETS_DESKTOP = 5;
const isSmall = computed(() => vuetify.breakpoint.smAndDown);
const hasProductSets = computed(() => Boolean(productSetIds.value.length > 0));

const productSets = computed(() => {
  const productSetStore = getProductSetsStore(store);
  const productSetIds = productSetStore.feeds[props.displayName]?.ids || [];
  return productSetIds
    .filter((id: string) => id !== props.currentId)
    .map((productSetId) => ({
      id: productSetId,
      tile: {
        class: "mr-2",
        "display-name": props.displayName,
        "product-set-id": productSetId,
        title: productSetStore.productSets[productSetId]?.title,
      },
      experimentCard: {
        class: "text-decoration-none mr-2",
        flat: true,
        width: 88,
      },
      experimentTile: {
        class: "collection-tile-border pa-1",
        "display-name": props.displayName,
        "product-set-id": productSetId,
        title: productSetStore.productSets[productSetId]?.title,
        outlined: true,
        width: 88,
        height: 88,
        experiment: true,
      },
    }));
});
const productSetIds = computed(() => {
  const productSetStore = getProductSetsStore(store);
  return (productSetStore.feeds[props.displayName]?.ids || []).filter((id: string) => id !== props.currentId);
});

const showSeeAll = computed(() => {
  const numOfProductSets = productSetIds.value.length;

  return vuetify.breakpoint.xsOnly
    ? numOfProductSets >= MIN_NUM_OF_PRODUCT_SETS_MOBILE
    : numOfProductSets >= MIN_NUM_OF_PRODUCT_SETS_DESKTOP;
});

const productSetAnalyticsEvents = () => {
  amplitude?.sendEvent("/page/publisher/view-all-product-sets", {
    "gift-guide": false,
  });
  getAmplitudeStore(store).setReferringComponent("creator shop product sets carousel");
  useCreatorShop().setReferringShopTab();
};

return { __sfc: true,props, store, amplitude, vuetify, MIN_NUM_OF_PRODUCT_SETS_MOBILE, MIN_NUM_OF_PRODUCT_SETS_DESKTOP, isSmall, hasProductSets, productSets, productSetIds, showSeeAll, productSetAnalyticsEvents }
}

})